import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from "react-redux"; // The Provider component is imported from the react-redux library. It is a higher-order component that provides the Redux store to the React application.
import {store} from "../src/redux/store.js"; // The store is imported from the store.js file
import  {persistor}  from "../src/redux/store.js";
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>{/*Then, we wrap our App component with the Provider function and pass the store as a prop. This makes the Redux store available to all the components inside the App */}
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
